import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Wrap any doctor-only route with this, e.g. in App.js:
//   <Route path="/doctor/dashboard" element={
//     <ProtectedDoctorRoute><DoctorDashboard /></ProtectedDoctorRoute>
//   } />
//
// Requires the `doctor` reducer to be registered in your store (see
// ROUTING_SETUP.txt) — without it, `state.doctor` is undefined and this
// will throw instead of redirecting.
const ProtectedDoctorRoute = ({ children }) => {
  const doctorState = useSelector((state) => state.doctor);
  const token = doctorState?.token || localStorage.getItem('doctor_token');

  if (!token) {
    return <Navigate to="/doctor/login" replace />;
  }

  return children;
};

export default ProtectedDoctorRoute;